import { render, staticRenderFns } from "./EntityTemplateCustomization.vue?vue&type=template&id=61c106ec&scoped=true"
import script from "./EntityTemplateCustomization.vue?vue&type=script&lang=js"
export * from "./EntityTemplateCustomization.vue?vue&type=script&lang=js"
import style0 from "./EntityTemplateCustomization.vue?vue&type=style&index=0&id=61c106ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c106ec",
  null
  
)

export default component.exports